import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import type { ReactNode } from 'react';

/**
 * Wraps `<ErrorBoundary>` and resets it whenever the route changes.
 *
 * Bug-hunt #96: the bare class boundary held `hasError: true` until it was
 * unmounted. Users who navigated away and came back to the same route still
 * saw the crash screen. This component supplies `resetKey={pathname}` so the
 * boundary auto-clears on any navigation.
 *
 * Use this for in-tree boundaries (per-section, per-route). For the app root
 * (above the router) keep using `<ErrorBoundary>` directly.
 */
export function RouteResettingErrorBoundary({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const location = useLocation();
  return (
    <ErrorBoundary resetKey={location.pathname} fallback={fallback}>
      {children}
    </ErrorBoundary>
  );
}
